import * as angular from 'angular';
import { TagDefinition } from '../../models';
import { ILoggerService } from '../general';

export interface ISaveMessagesService {
    saveTag(promise: angular.IPromise<TagDefinition[]>): angular.IPromise<TagDefinition[]>;
}

export class SaveMessagesService implements ISaveMessagesService {
    static serviceId: string = 'saveMessagesService';

    static $inject = ['loggerService'];

    constructor(
        private _loggerService: ILoggerService
    ) { }


    saveTag(promise: angular.IPromise<TagDefinition[]>): angular.IPromise<TagDefinition[]> {
        return promise
            .then(tags => {
                this._loggerService.logSuccess('Successfully updated tag.');
                return tags;
            })
            .catch(reason => {
                this._loggerService.logError('Failed to save tag.');
                return reason;
            });
    }
}